/**
 * @return {void}
 */
module.exports = function destroyRoiGateForm() {
    document.querySelectorAll('[data-component="roi-calculator-gate-form-backdrop"]').forEach(backdrop => {
        backdrop.remove();
    });
}